import { FC, ReactElement } from "react"
import { useFormikContext } from "formik"

import { tenantOptions } from "../../../constants/bonus"
import { enumCMSTypes } from "../../../constants/cms"
import { DropdownMenu } from "../../inputs/DropdownMenu"
import { InputField } from "../../inputs/InputField"
import { TitledCheckbox } from "../../inputs/TitledCheckbox"

import { FormValuesType } from "./ModalCMS"

type MainFieldsProps = {
  type: enumCMSTypes
}
export const MainFields: FC<MainFieldsProps> = ({ type }): ReactElement => {
  const { values, handleChange, touched, errors } = useFormikContext<FormValuesType>()
  return (
    <>
      <div className="w-full">
        <InputField
          id="name"
          title="Name"
          value={values.name}
          onChange={handleChange}
          invalid={!!(touched.name && errors.name)}
          altLabelTwo={touched.name ? errors.name : ""}
        />
      </div>
      <div className="w-full">
        <DropdownMenu
          id="tenant_id"
          title="Tenant"
          options={tenantOptions}
          value={values.tenant_id}
          onChange={handleChange}
          placeholder="Please choose an option"
          invalid={Boolean(touched.tenant_id && errors.tenant_id)}
          altLabelOne={touched.tenant_id ? errors.tenant_id : ""}
        />
      </div>
      <div className="flex justify-between my-4">
        <div className="w-2/5">
          <TitledCheckbox id="active" title="Active banner" checked={values.active} onChange={handleChange} />
        </div>
        {type === enumCMSTypes.HOMEPAGE_BANNER && (
          <div className="w-2/5">
            <TitledCheckbox id="jackpots" title="Show jackpots counts" checked={values.jackpots} onChange={handleChange} />
          </div>
        )}
      </div>
      {type === enumCMSTypes.HOMEPAGE_BANNER ? (
        <div className="w-full">
          <InputField
            id="order"
            title="Order"
            value={values.order}
            onChange={handleChange}
            invalid={!!(touched.order && errors.order)}
            altLabelTwo={touched.order ? errors.order : ""}
            type="number"
          />
        </div>
      ) : null}
      {type === enumCMSTypes.HOMEPAGE_BANNER ? (
        <div className="w-full">
          <InputField
            id="link"
            title="General link"
            value={values.link}
            onChange={handleChange}
            invalid={!!(touched.link && errors.link)}
            altLabelTwo={touched.link ? errors.link : ""}
            type="url"
          />
        </div>
      ) : null}
    </>
  )
}
